<script lang="ts">
  import RangeInput from "./RangeInput.svelte"
  import NumberInput from "./NumberInput.svelte"

  export let label: string
  export let unit: string
  export let name: string | undefined = undefined
  export let value: number
  export let min: string | undefined = undefined
  export let max: string | undefined = undefined
  export let step: string | undefined = undefined
  export let altValues: boolean = false
  export let altValuesArray: any | undefined = undefined
  let displayedValue: any

  $: if (altValuesArray) {
    displayedValue = altValuesArray[value]
  }
</script>

<div class="flex flex-col gap-5">
  <div class="flex w-full justify-between items-baseline flex-col lg:flex-row max-lg:gap-2.5">
    <label class="text-label" for={name}>
      {label}
      <span class="text-sm text-white/75 font-medium">{unit}</span>
    </label>
    {#if altValues}
      <NumberInput value={displayedValue} readonly />
    {:else}
      <NumberInput bind:value {name} {min} {max} {step} />
    {/if}
  </div>
  <RangeInput bind:value {name} {min} {max} {step} />
</div>
